/** @jsx h */
import { h } from 'preact'
import CloseButton from './CloseButton'

const Modal = ({ show, onClose, children }) => {
  // Render nothing if the "show" prop is false
  if (!show) {
    return null
  }

  return (
    <div class='CardModal-backdrop'>
      <div class='CardModal'>
        <CloseButton onClose={onClose} />
        {children}
      </div>
    </div>
  )
}

Modal.defaultProps = {
  show: false,
  children: []
}

export default Modal
